define.alias("shared/components/shared/platform-notice", "settings/components/shared/platform-notice");